import React from "react";
import { ReactNode } from "react";
import { FaChevronDown } from "react-icons/fa6";

import "./Panel.Component.scss";

interface Props {
  open?: boolean; // This is for controlling the open state of the panel. If left undefined, it will handle it's own state.
  onToggle?: () => void;
  header?: React.ReactNode;
  headerRight?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  toggleOn?: PanelToggleOn[]; // Only set this to controll what part triggers the toggle.
  titleToggles?: boolean;
  disableToggle?: boolean;
  chevronPosition?: PanelChevron;
  style?: PanelStyle;
}

interface State {
  isOpen: boolean;
}

enum PanelToggleOn {
  HEADER = "toggle_header",
  CHEVRON = "toggle_chevron",
  HEADER_RIGHT = "toggle_headerRight",
}

enum PanelChevron {
  LEFT = "chevron-left",
  RIGHT = "chevron-right",
  NONE = "",
}
enum PanelStyle {
  DEFAULT = "style-default",
  GREY = "style-grey",
}

export class Panel extends React.Component<Props, State> {
  static Style = PanelStyle;
  static Chevron = PanelChevron;
  static ToggleOn = PanelToggleOn;
  style = PanelStyle.DEFAULT;
  chevron = PanelChevron.RIGHT;
  toggleOn: PanelToggleOn[] = [];

  constructor(props: Props) {
    super(props);
    this.state = { isOpen: props.open || false };
    this.toggleOpen = this.toggleOpen.bind(this);
    this.headerClicked = this.headerClicked.bind(this);
    this.toggleClicked = this.toggleClicked.bind(this);
    this.style = props.style || PanelStyle.DEFAULT;
    this.chevron = props.chevronPosition || PanelChevron.RIGHT;
    this.toggleOn = props.toggleOn ? props.toggleOn : [PanelToggleOn.CHEVRON];
  }
  toggleOpen() {
    if (typeof this.props.open !== "boolean") {
      this.setState({ isOpen: !this.state.isOpen });
    }
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  }
  headerClicked() {
    const { disableToggle, toggleOn } = this.props;

    if (disableToggle || toggleOn) {
      return;
    }
    this.toggleOpen();
  }
  toggleClicked() {
    const { disableToggle } = this.props;
    if (disableToggle) {
      return;
    }
    this.toggleOpen();
  }

  render(): ReactNode {
    const { isOpen } = this.state;
    const { header, headerRight, children, className, toggleOn } = this.props;
    const isSimplePanel = !header && !headerRight;
    const open = isSimplePanel ? true : typeof this.props.open === "boolean" ? this.props.open : isOpen;

    return (
      <div className={`SSPanel ${open ? "isOpen" : "isClosed"} ${className} ${toggleOn ? toggleOn.join(" ") : "toggle_all"} ${this.style}`}>
        {(header || headerRight) && (
          <div className={"PanelHeader"} onClick={this.headerClicked}>
            {this.chevron === PanelChevron.LEFT && (
              <div className="chevron" onClick={toggleOn?.includes(PanelToggleOn.CHEVRON) ? this.toggleClicked : undefined}>
                <FaChevronDown />
              </div>
            )}
            <div className="PanelHeaderLeft" onClick={toggleOn?.includes(PanelToggleOn.HEADER) ? this.toggleClicked : undefined}>
              {header}
            </div>
            {headerRight && (
              <div className="PanelHeaderRight" onClick={toggleOn?.includes(PanelToggleOn.HEADER_RIGHT) ? this.toggleClicked : undefined}>
                {headerRight}
              </div>
            )}
            {this.chevron === PanelChevron.RIGHT && (
              <div className="chevron" onClick={toggleOn?.includes(PanelToggleOn.CHEVRON) ? this.toggleClicked : undefined}>
                <FaChevronDown />
              </div>
            )}
          </div>
        )}

        <div className="PanelContent">
          <div className="PanelContentInner">
            <div className="PanelContentInnerContent [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-md [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-grey-400 [&::-webkit-scrollbar-thumb]:rounded-md">
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
